"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetchClient = require("@nike/fetch-client");
var _uxTreadDotcomConstants = require("@nike/ux-tread-dotcom-constants");
var _trackEvent = _interopRequireWildcard(require("../../../../../../../analytics/track-event"));
var _getQueryKey = _interopRequireDefault(require("../../get-query-key"));
var _getQueryKey2 = _interopRequireDefault(require("../summary/get-query-key"));
var _getOptions = require("../../../fetch-default-list/get-options");
var _getMarketplace = _interopRequireDefault(require("../../../../../../global-config/get-marketplace"));
var _getQueryKey3 = _interopRequireDefault(require("../../../../../carts/v2/get-query-key"));
var _getQueryKey4 = _interopRequireDefault(require("../../../../../../product-feed-threads/v2/get-query-key"));
var _deriveUrlWithFragment = _interopRequireDefault(require("../../../../../../../utils/derive-url-with-fragment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var pageActionName = 'tread-wishlist-event';
var makePdpUrl = function makePdpUrl(_ref) {
  var slug = _ref.slug,
    styleColor = _ref.styleColor;
  return slug && styleColor ? (0, _deriveUrlWithFragment["default"])("t/".concat(slug, "/").concat(styleColor)) : undefined;
};
var getAddToWishlistOptionsV2 = function getAddToWishlistOptionsV2(_ref2) {
  var queryClient = _ref2.queryClient;
  var itemId = null;
  return {
    onMutate: function () {
      var _onMutate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref3) {
        var gtin, productCode, wishlistId, previousWishlist;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              gtin = _ref3.gtin, productCode = _ref3.productCode;
              itemId = window.crypto.randomUUID();
              _context.n = 1;
              return (0, _getOptions.getDefaultListId)({
                queryClient: queryClient
              });
            case 1:
              wishlistId = _context.v;
              _context.n = 2;
              return queryClient.cancelQueries((0, _getQueryKey["default"])({
                id: wishlistId
              }));
            case 2:
              previousWishlist = queryClient.getQueryData((0, _getQueryKey["default"])({
                id: wishlistId
              }));
              queryClient.setQueryData((0, _getQueryKey["default"])({
                id: wishlistId
              }), function (previousWishlist) {
                var _previousWishlist$pag, _previousWishlist$pag2;
                var previousItems = (previousWishlist === null || previousWishlist === void 0 || (_previousWishlist$pag = previousWishlist.pages[0]) === null || _previousWishlist$pag === void 0 ? void 0 : _previousWishlist$pag.objects) || [];
                var updatedList = _objectSpread(_objectSpread({}, previousWishlist), {}, {
                  pages: [{
                    // Always add the new item to the top of the list. This will break if we ever permit wishlist filtering/sorting.
                    objects: [{
                      id: itemId,
                      gtin: gtin,
                      productCode: productCode
                    }].concat(_toConsumableArray(previousItems)),
                    pages: previousWishlist === null || previousWishlist === void 0 || (_previousWishlist$pag2 = previousWishlist.pages[0]) === null || _previousWishlist$pag2 === void 0 ? void 0 : _previousWishlist$pag2.pages
                  }]
                });
                return updatedList;
              });
              return _context.a(2, {
                previousWishlist: previousWishlist
              });
          }
        }, _callee);
      }));
      function onMutate(_x) {
        return _onMutate.apply(this, arguments);
      }
      return onMutate;
    }(),
    mutationFn: function () {
      var _mutationFn = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref4) {
        var _window;
        var gtin, productCode, _yield$Promise$all, _yield$Promise$all2, marketplace, token, wishlistId;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              gtin = _ref4.gtin, productCode = _ref4.productCode;
              _context2.n = 1;
              return Promise.all([(0, _getMarketplace["default"])(), (_window = window) === null || _window === void 0 || (_window = _window.webShellClient) === null || _window === void 0 || (_window = _window.identity) === null || _window === void 0 ? void 0 : _window.getAccessToken(), (0, _getOptions.getDefaultListId)({
                queryClient: queryClient
              })]);
            case 1:
              _yield$Promise$all = _context2.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              marketplace = _yield$Promise$all2[0];
              token = _yield$Promise$all2[1];
              wishlistId = _yield$Promise$all2[2];
              if (wishlistId) {
                _context2.n = 2;
                break;
              }
              throw new Error('Cannot add item to wishlist: no default list ID found.');
            case 2:
              return _context2.a(2, (0, _fetchClient.fetchClient)("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/wishlists/v2/lists/").concat(wishlistId, "/items/").concat(itemId), {
                method: 'PUT',
                headers: (0, _fetchClient.formatHeaders)({
                  token: token,
                  appId: _uxTreadDotcomConstants.DOTCOM_UX_ID
                }),
                body: JSON.stringify({
                  gtin: gtin,
                  productCode: productCode,
                  marketplace: marketplace
                })
              }, 'Error adding item to wishlist.', {
                pageActionName: pageActionName
              }));
          }
        }, _callee2);
      }));
      function mutationFn(_x2) {
        return _mutationFn.apply(this, arguments);
      }
      return mutationFn;
    }(),
    onError: function () {
      var _onError = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(err, _, context) {
        var wishlistId;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _getOptions.getDefaultListId)({
                queryClient: queryClient
              });
            case 1:
              wishlistId = _context3.v;
              queryClient.setQueryData((0, _getQueryKey["default"])({
                id: wishlistId
              }), context.previousWishlist);
              window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
              return _context3.a(2, err);
          }
        }, _callee3);
      }));
      function onError(_x3, _x4, _x5) {
        return _onError.apply(this, arguments);
      }
      return onError;
    }(),
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data, variables) {
        var _cart$items;
        var cart, cartItem, productId, skuId, currency, productFeedData, pid, category, brand, styleColor, content, _ref5, productName, slug, pdpUrl, _cartItem$priceInfo, _cartItem$priceInfo2, _cartItem$priceInfo3, _cartItem$priceInfo4, _window$webShellClien, toUnitsNanos, getProtoEnums, CurrencyEnums, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              queryClient.setQueryData((0, _getQueryKey["default"])({
                id: data.wishlistId
              }), function (currentWishlist) {
                var _currentWishlist$page, _currentWishlist$page2;
                var previousItems = (currentWishlist === null || currentWishlist === void 0 || (_currentWishlist$page = currentWishlist.pages[0]) === null || _currentWishlist$page === void 0 ? void 0 : _currentWishlist$page.objects) || [];
                var updatedList = _objectSpread(_objectSpread({}, currentWishlist), {}, {
                  pages: [{
                    objects: previousItems.map(function (item) {
                      if (item.id === data.id) {
                        return data;
                      }
                      return item;
                    }),
                    pages: currentWishlist === null || currentWishlist === void 0 || (_currentWishlist$page2 = currentWishlist.pages[0]) === null || _currentWishlist$page2 === void 0 ? void 0 : _currentWishlist$page2.pages
                  }]
                });
                return updatedList;
              });
              queryClient.invalidateQueries((0, _getQueryKey2["default"])({
                listId: data.wishlistId
              }));
              cart = queryClient.getQueryData((0, _getQueryKey3["default"])());
              cartItem = cart === null || cart === void 0 || (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.find(function (item) {
                return item.productCode === variables.productCode;
              });
              productId = variables.productId || data.productId || (cartItem === null || cartItem === void 0 ? void 0 : cartItem.productId);
              skuId = variables.skuId || data.skuId || (cartItem === null || cartItem === void 0 ? void 0 : cartItem.skuId);
              currency = cart === null || cart === void 0 ? void 0 : cart.currency;
              productFeedData = queryClient.getQueryData((0, _getQueryKey4["default"])({
                productId: productId,
                styleColor: variables.productCode
              })) || {};
              pid = productFeedData.pid, category = productFeedData.productType, brand = productFeedData.brand, styleColor = productFeedData.styleColor, content = productFeedData.content;
              _ref5 = content || {}, productName = _ref5.title, slug = _ref5.slug;
              pdpUrl = makePdpUrl({
                slug: slug,
                styleColor: styleColor
              });
              try {
                (0, _trackEvent["default"])(_trackEvent.PRODUCT_SAVED, {
                  brand: brand,
                  cartId: cart === null || cart === void 0 ? void 0 : cart.id,
                  category: category,
                  cloudProductId: productId,
                  productCode: variables.productCode,
                  productId: pid,
                  productName: productName,
                  gtin: variables.gtin,
                  currency: currency,
                  price: cartItem === null || cartItem === void 0 || (_cartItem$priceInfo = cartItem.priceInfo) === null || _cartItem$priceInfo === void 0 ? void 0 : _cartItem$priceInfo.total,
                  fullPrice: cartItem === null || cartItem === void 0 || (_cartItem$priceInfo2 = cartItem.priceInfo) === null || _cartItem$priceInfo2 === void 0 ? void 0 : _cartItem$priceInfo2.fullPriceTotal,
                  prodigyProductId: pid,
                  quantity: 1,
                  sku: skuId,
                  styleColor: styleColor,
                  pdpUrl: pdpUrl,
                  url: pdpUrl,
                  wishlistId: data.wishlistId,
                  wishlistItemId: data.id
                }, {
                  telemetryData: variables,
                  usePageAction: true
                });
              } catch (e) {
                // Swallow analytics errors to avoid impacting user experience.
              }
              _context4.p = 1;
              if (!(variables.productCode && currency)) {
                _context4.n = 3;
                break;
              }
              _window$webShellClien = window.webShellClient.analytics.utils, toUnitsNanos = _window$webShellClien.toUnitsNanos, getProtoEnums = _window$webShellClien.getProtoEnums;
              _context4.n = 2;
              return getProtoEnums('Currency');
            case 2:
              CurrencyEnums = _context4.v;
              window.webShellClient.analytics.trackAction({
                underlyingAction: {
                  "case": 'coreCommerceV1ProductFavorited',
                  value: {
                    productCode: variables.productCode,
                    product: {
                      productId: {
                        "case": 'productCode',
                        value: {
                          value: variables.productCode
                        }
                      },
                      currency: CurrencyEnums[currency === null || currency === void 0 ? void 0 : currency.toUpperCase()],
                      fullPrice: toUnitsNanos(cartItem === null || cartItem === void 0 || (_cartItem$priceInfo3 = cartItem.priceInfo) === null || _cartItem$priceInfo3 === void 0 ? void 0 : _cartItem$priceInfo3.fullPriceTotal),
                      currentPrice: toUnitsNanos(cartItem === null || cartItem === void 0 || (_cartItem$priceInfo4 = cartItem.priceInfo) === null || _cartItem$priceInfo4 === void 0 ? void 0 : _cartItem$priceInfo4.total)
                    }
                  }
                }
              }, {
                eventVersion: 2
              });
            case 3:
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t = _context4.v;
            case 5:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 4]]);
      }));
      function onSuccess(_x6, _x7) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }()
  };
};
var _default = exports["default"] = getAddToWishlistOptionsV2;